import { IGroup } from "./../../entities";
import { provider } from "../../providers";

export interface GroupData {
  id: number;
  playerId: number;
  name: string;
  group_logo?: string | null;
  created_at: string;
}

export interface CreateGroupPayload {
  createGroup: GroupData[];
}

export const CreateGroup = async (params: CreateGroupPayload): Promise<IGroup> =>
  provider.Request("/create-group", params);
